export function isNil(variable) {
  if (typeof variable === 'undefined' || variable === null) {
    return true
  }

  return false
}
